import './Stepper.scss';

import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

interface IProps {
  steps: string[];
  activeIndex: number;
}

function Stepper({ steps, activeIndex }: IProps) {
  const { t } = useTranslation();

  return (
    <ol className="modStepper">
      {steps.map((step, i) => {
        const className = classNames('modStepper__step', {
          'modStepper__step--active': i === activeIndex,
          'modStepper__step--completed': i < activeIndex,
        });
        return (
          <li key={i} className={className}>
            <strong className="modStepper__step__title">
              {t('general.step')} {i + 1}
            </strong>
            <p className="modText modText--body1">{step}</p>
          </li>
        );
      })}
    </ol>
  );
}

export default Stepper;
